/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

export const strings = {
  title: 'License',
  subtitle: 'General figures',

  fields: {
    companyName: 'Client Name',
    licenseType: 'Licesne Type',
    startDate: 'Start Date',
    duration: 'Duration',
    daysLeft: 'Remaining Days',
    expirationDate: 'End Date',
    usersNumber: 'User Number',
    consumedAccounts: 'Consumed Accounts',
    remainingAccounts: 'Remaining Accounts',
    featureSet: 'Feature Set',
    operationType: 'Operation Type',

    spent: 'Consumed',
  },

  state: {
    active: 'Active',
    expiring: 'Expiring soon',
    expired: 'Expired',
  },

  operations: {
    new: 'New licence',
    update: 'Update',
    renew: 'Renewal',
    'public-key': 'Public key',
  },

  licenseTypes: {
    Open: 'Open',
    Close: 'Closed',
    TimeStamp: 'Time limited',
    NumberOfUsers: 'User limited',
    NumberOfUsersAndTimeStamp: 'User and time limited',
  },

  features: {
    Lms: 'Learning programs',
    Policies: 'Policies',
    Phishing: 'Phishing',
    SecurityReports: 'Security reports',
    Assessments: 'Assessments',
    AwarenessContent: 'Awareness content',
    Gamififcation: 'Gamification',
    Surveys: 'Surveys',
  },

  history: {
    title: 'License Information',
    licenseType: 'Licence Type',
    startDate: 'Start Date',
    durationDays: 'Total Days',
    totalAccounts: 'Total License Count',
  },

  update: {
    trigger: 'Update License',
    submit: 'Update License',
    fileLabel: 'License File',
    renewOptions: 'Renew Options',
    noCopy: 'Do not copy anything and start with fresh license',
    copy: 'Copy all existing user from the old license to the new license',
    contentHeading: 'License Data Parsed:',
    emptyFile: 'There was no file selected!',
    failed: 'The license could not be updated, please try again',
    wrongFileType: 'Only .json files are accepted',
    invalidLicense:
      'The Licesne file may be corrupted or not issued by Coeia, can not proceed!',
    success: 'Licesne data updated successfully',
    error:
      'An unexpected error occurred while updating the license. Please try again or contact us',
    noLicense: 'No license were found in the system, can not proceed!',

    submitting: 'Please wait...',
    fileHint: 'The licence file issued by CoEIA, as a .json document',
    notJson: 'The file could not be read; make sure it is a valid licence file',
    noLicenseInfo: 'This file carries no licence information',
    wrongOperation: 'This file is of a type this screen does not apply; use an update or renew file.',

    preview: {
      clientName: 'Client',
      operationType: 'Operation',
      licenseType: 'Licence type',
      startDate: 'Start date',
      usersNumber: 'Users',
      duration: 'Duration',
      featureSet: 'Features',
      days: (n) => `${n} days`,
      allFeatures: 'All features',
      featuresIncluded: 'Features included',
      featuresAll: 'This licence is not limited to any feature',
      featuresSome: (n, total) => `${n} of ${total} features`,
      excluded: 'Not included',
    },
  },


  unavailable: '—',
  close: 'Close',
}
